<template>
    <div>
        <HeaderPage></HeaderPage>
        <div class="content">
            <SlideShow></SlideShow>
        </div>
        <SuccessText></SuccessText>
        <FooterPage></FooterPage>
    </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue';
import SlideShow from '@/components/SlideShow.vue';
import FooterPage from '@/components/FooterPage.vue';
import SuccessText from '@/components/SuccessText.vue';

export default {
    name: 'SuccessCases',
    components: {
        HeaderPage,
        SlideShow,
        FooterPage,
        SuccessText
    },
}
</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}
</style>